import React from 'react';
import styles from './AccountIcon.module.scss';
import importAllFiles from '@support/importAllFiles';
import { useTheme } from '@hooks/use-theme';
import { IntegrationType, IntegrationProvider } from '@models/Integration';
import googleLogo from '@app/img/onboarding/google.svg';
import microsoftLogo from '@app/img/onboarding/msft.svg';
import linkedinLogo from '@app/img/onboarding/linkedin.svg';
import twitterLogo from '@app/img/onboarding/twitter.svg';
import messagesLogo from '@app/img/onboarding/msg.svg';
import contactsLogo from '@app/img/onboarding/contacts.svg';
import facebookLogo from '@app/img/onboarding/facebook.svg';
import whatsappLogo from '@app/img/onboarding/whatsapp.svg';
import whatsappLogoLight from '@app/img/onboarding/whatsapp_light.svg';
import fileLogo from '@app/img/onboarding/file.svg';
import fileLogoLight from '@app/img/onboarding/file_light.svg';
import calendarLogo from '@app/img/onboarding/calendar.svg';
import phoneLogo from '@app/img/onboarding/phone.svg';

import cn from 'classnames';

const icons = importAllFiles(import.meta.glob('/public/img/contact/icons/source/*.svg'));
const availableSmallIntegrationTypeIcons: (IntegrationType | IntegrationProvider)[] = [
  'email',
  'calendar',
  'twitter-platforms',
  'twitter',
  'linkedin',
  'facebook',
  'apple-messages',
  'apple-contacts',
  'contacts',
  'card-dav',
  'chatgpt',
  'notion',
  'zapier',
  'whatsapp',
  // 'linkedin-csv',
];
const providerToIcon = {
  'google': googleLogo,
  'microsoft': microsoftLogo,
  'twitter-platforms': twitterLogo,
  'twitter': twitterLogo,
  'linkedin': linkedinLogo,
  'apple-messages': messagesLogo,
  'contacts': contactsLogo,
  'facebook': facebookLogo,
  'apple-calendar': calendarLogo,
  'apple-phone-log': phoneLogo,
  'whatsapp': whatsappLogo,
  'whatsapp_light': whatsappLogoLight,

  'file': fileLogo,
  'linkedin-csv': fileLogo,
  'csv': fileLogo,

  'file_light': fileLogoLight,
  'linkedin-csv_light': fileLogoLight,
  'csv_light': fileLogoLight,
};

// IntegerationProviderIcon
export const AccountIconLarge = ({
  className,
  providerOrType,
}: {
  className?: string;
  providerOrType: IntegrationProvider | 'file';
}) => (
  <img
    className={cn(className, 'integration-option-icon')}
    src={providerToIcon[providerOrType]}
    width="24"
    height="24"
  />
);

// IntegrationTypeIcon
export const AccountIconSmall = ({
  type: integrationType,
  provider,
  className,
}: {
  type?: IntegrationType;
  provider?: IntegrationProvider;
  className?: string;
}) => {
  const [theme] = useTheme();
  let icon = providerToIcon[`${provider}_${theme}`] || providerToIcon[provider];

  if (availableSmallIntegrationTypeIcons.includes(integrationType)) {
    icon = icons[`${integrationType}_${theme}`] || icons[integrationType];
  } else if (availableSmallIntegrationTypeIcons.includes(provider)) {
    icon = icons[`${provider}_${theme}`] || icons[provider];
  } else if (provider === 'apple-calendar') {
    icon = icons[`calendar_${theme}`] || icons['calendar'];
  } else if (['linkedin-csv', 'csv'].includes(provider)) {
    icon = icons[`csv_${theme}`] || icons['csv'];
  }

  // if (provider === 'linkedin-csv') {
  //   console.log('provider:', provider);
  //   console.log('icon:', icon);
  // }

  return icon ? (
    <span
      className={cn(styles.icon, className, 'integration-option-icon')}
      style={{
        backgroundImage: `url(${icon})`,
        backgroundSize: 'contain',
      }}
    />
  ) : (
    <span className={cn(styles.icon, className, 'integration-option-icon')} />
  );
};

export const ConnectedAccountIcon = ({ children }) => (
  <div className={cn(styles.iconContainer, 'connected-account-icon-container')}>
    {children}
    {children}
  </div>
);
